import React, { FC } from "react";
import NcModal from "components/NcModal/NcModal";
import Tag from "components/Tag/Tag";
import { TaxonomyType } from "data/types";
import Button from "components/Button/Button";
import { ChevronDownIcon } from "@heroicons/react/24/solid";

export interface ModalTagsProps {
  tags: TaxonomyType[];
}

const ModalTags: FC<ModalTagsProps> = ({ tags }) => {
  const renderModalContent = () => {
    return (
      <div className="flex flex-wrap dark:text-neutral-200">
        {tags.map((tag) => (
          <Tag key={tag.id} tag={tag} className="mr-2 mb-2" />
        ))}
      </div>
    );
  };

  return (
    <div className="nc-ModalTags">
      <NcModal
        contentExtraClass="max-w-screen-md"
        renderTrigger={(openModal) => (
          <Button
            id = "boutonCategorie"
            pattern="third"
            fontSize="text-sm font-medium"
            onClick={openModal}
          >
            
            <div>
              <span className="hidden sm:inline">Catégorie</span>
            </div>
            <ChevronDownIcon
              className="w-4 h-4 ml-2 -mr-1"
              aria-hidden="true"
            />
          </Button>
        )}
        modalTitle="Sélectionnez une catégorie:"
        renderContent={renderModalContent}
      />
    </div>
  );
};

export default ModalTags;
